export default () => {
  const vendor = +process.env.VUE_APP_PADDLE_ID;
  window.Paddle.Setup({ vendor });
};
